<template>
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2000 45">
		<path v-if="!reverse" d="M0,45 S400,0,1000,0,2000,45,2000,45Z" :fill="fill" :stroke="stroke" :stroke-width="strokewidth" />
		<path v-else d="M0,45 C0,45,400,0,1000,0 s1000,45,1000,45 V0 H0 V45z" :fill="fill" :stroke="stroke" :stroke-width="strokewidth" />
	</svg>
</template>
<style scoped lang="scss">
	svg{
		display: block;
		width: 100%;
	}
</style>
<script>
	export default{
		props: {
			fill:{ default:'var(--white)' },
			stroke:{ default:'red' },
			strokewidth:{ default:'0' },
			reverse:{ default:false },
		},
	}
</script>
